var firebaseConfig = {
    apiKey: "AIzaSyAEwa2LgPCncyBw_vPiWnkA5kOxg3G8lfI",
    authDomain: "authentication-cef67.firebaseapp.com",
    projectId: "authentication-cef67",
    storageBucket: "authentication-cef67.appspot.com",
    messagingSenderId: "1039989026421",
    appId: "1:1039989026421:web:f3ac9f00f13f5136c1923c"
  };
  export default firebaseConfig;